"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TumblrSquare;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function TumblrSquare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#010101;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "Tumblr"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "tumblr-square"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-2",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M81.429,92.5H18.571A11.084,11.084,0,0,1,7.5,81.429V18.571A11.084,11.084,0,0,1,18.571,7.5H81.429A11.084,11.084,0,0,1,92.5,18.571V81.429A11.084,11.084,0,0,1,81.429,92.5Zm-62.858-80A6.079,6.079,0,0,0,12.5,18.571V81.429A6.079,6.079,0,0,0,18.571,87.5H81.429A6.079,6.079,0,0,0,87.5,81.429V18.571A6.079,6.079,0,0,0,81.429,12.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M62.289,68.4c-1.116,1.189-4.1,2.6-7.99,2.6-9.909,0-12.058-7.284-12.058-11.534V47.654h-3.9a.822.822,0,0,1-.82-.82V41.255a1.388,1.388,0,0,1,.927-1.312c5.086-1.788,6.685-6.234,6.915-9.606.066-.9.533-1.337,1.321-1.337H52.5a.822.822,0,0,1,.82.82v9.45h6.809a.816.816,0,0,1,.82.812v6.7a.823.823,0,0,1-.82.821H53.29V58.531c0,2.806,1.944,4.4,5.578,2.937a1.73,1.73,0,0,1,1.042-.181.886.886,0,0,1,.607.649l1.8,5.274c.147.41.271.87-.033,1.19Z"
  })))));
}